import React from "react";
import { Collapse } from "react-collapse";
import asPage from "components/core/as-page";
import Breadcrumbs from "components/core/breadcrumbs";
import Header from "components/core/header";
import HeaderBanner from "components/core/header-banner";
import Layout from "components/core/layout";
import FormattedPrice from "components/elements/formatted-price";
import SVG from "components/elements/svg";
import TextContent from "components/elements/text-content";
import API from "services/api";

class Testimonials extends React.Component {
  static getInitialProps({ res, tokens, query }) {
    return new Promise((resolve) => {
      new API()
        .get(`/testimonials/${query.type}`, {}, tokens.token)
        .then((response) =>
          resolve({
            status: 200,
            type: query.type,
            testimonials: response.data,
          }),
        )
        .catch((error) => {
          const statusCode = error.code;
          if (res) {
            res.statusCode = statusCode;
          }
          resolve({
            status: statusCode,
            type: query.type,
            testimonials: {},
          });
        });
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      opened: null,
    };
  }

  render() {
    const { testimonials, type } = this.props;
    const { opened } = this.state;

    return (
      <Layout className="testimonials" title="Testimonials">
        <Header>
          <HeaderBanner
            title={`Testimonials${type ? ` - ${type.toLowerCase()}` : ""}`}
            icon="testimonials"
            background="/static/images/header-testimonials.jpg"
          />
        </Header>

        <Breadcrumbs>
          <Breadcrumbs.Item url="testimonials" title="Testimonials" />
          {!!type && (
            <Breadcrumbs.Item
              url={`testimonials/${type}`}
              title={`${type.charAt(0).toUpperCase()}${type
                .slice(1)
                .toLowerCase()}`}
            />
          )}
        </Breadcrumbs>

        <section className="testimonials__content">
          <div className="container">
            {testimonials.map((item, key) => {
              const id = key;
              return (
                <div className="testimonials__box" key={id}>
                  <div className="testimonials__box__header">
                    <div className="testimonials__box__header__top">
                      <p className="title">Case study #{key + 1}</p>
                      <button
                        type="button"
                        className="toggle"
                        onClick={() =>
                          this.setState({ opened: opened === id ? null : id })
                        }
                      >
                        {`${opened === id ? "Hide review" : "Read review"}`}
                        <SVG src="angle-down" className="icon" />
                      </button>
                    </div>
                    <div className="testimonials__box__header__bottom">
                      <div className="attributes">
                        {!!item.finalPrice && (
                          <div className="attribute sold">
                            <SVG src="reasons-2" className="icon" />
                            <p>
                              <span>Sold</span>
                              <span>
                                <FormattedPrice price={item.finalPrice} />
                              </span>
                            </p>
                          </div>
                        )}

                        {!!item.reservePrice && (
                          <div className="attribute reserve">
                            <SVG src="home-hand" className="icon" />
                            <p>
                              <span>Reserve</span>
                              <span>
                                <FormattedPrice price={item.reservePrice} />
                              </span>
                            </p>
                          </div>
                        )}

                        {!!item.numberOfBids && (
                          <div className="attribute bids">
                            <SVG src="our-way-2" className="icon" />
                            <p>
                              <span>No. of bids</span>
                              <span>{item.numberOfBids}</span>
                            </p>
                          </div>
                        )}
                      </div>

                      <div className="attribute author">
                        <p>
                          <span>
                            {item.name} {item.surname}, {item.role}
                          </span>
                          <span>{item.company}</span>
                        </p>
                        <SVG
                          src={`${item.sex === "m" ? "solicitor" : "female"}`}
                          className="icon"
                        />
                      </div>
                    </div>
                  </div>
                  <Collapse isOpened={opened === id}>
                    <div className="testimonials__box__content clearfix">
                      {item.image && (
                        <img
                          src={item.image}
                          className="img-responsive image"
                          alt={`Case Study ${key + 1}`}
                        />
                      )}
                      <TextContent className="text" content={item.content} />
                    </div>
                  </Collapse>
                </div>
              );
            })}
          </div>
        </section>
      </Layout>
    );
  }
}

export default asPage(Testimonials);
